import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Form, Input, Button, Alert } from "antd";
import util from "digimaker-ui/util";
import Cookies from "universal-cookie";
import logo from "../images/icd-logo.png";

const BLUE = "#003c7f";
const BLUE_DARK = "#002d60";
const ORANGE = "#FF7A00";

export const Login = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const history = useHistory();

  const onFinish = async (values: any) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch("/api/auth/auth", {
        method: "POST",
        body: JSON.stringify({
          username: values.username,
          password: values.password,
        }),
      });
      const result = await response.json();
      if (result && result.error === false) {
        new Cookies().set(util.getCookieKey(), result.data.refresh_token);
        history.push("/");
      } else if (result.error === true && result.data) {
        setError(result.data.message);
      } else {
        setError("Login failed. Please try again.");
      }
    } catch (e) {
      setError("Network error or invalid credentials.");
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: `linear-gradient(150deg, ${BLUE_DARK} 0%, ${BLUE} 100%)`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
      }}
    >
      {/* Decorative circles echoing the orange dots in the logo */}
      <div style={{
        position: "fixed", top: "6%", right: "10%",
        width: 200, height: 200, borderRadius: "50%",
        background: ORANGE, opacity: 0.12, pointerEvents: "none",
      }} />
      <div style={{
        position: "fixed", bottom: "10%", left: "6%",
        width: 300, height: 300, borderRadius: "50%",
        background: ORANGE, opacity: 0.08, pointerEvents: "none",
      }} />

      <div style={{
        width: "100%",
        maxWidth: 420,
        borderRadius: 16,
        boxShadow: "0 32px 80px rgba(0,0,0,0.45)",
        overflow: "hidden",
      }}>
        {/* Logo header — same blue as logo background so logo blends in */}
        <div style={{
          background: BLUE,
          padding: "40px 40px 32px",
          textAlign: "center",
          borderBottom: `4px solid ${ORANGE}`,
        }}>
          <img src={logo} alt="ICD Logo" style={{ height: 64, marginBottom: 10 }} />
          <p style={{
            color: "rgba(255,255,255,0.5)",
            margin: 0,
            fontSize: 12,
            letterSpacing: "0.12em",
            textTransform: "uppercase",
          }}>
            Management System
          </p>
        </div>

        {/* Form */}
        <div style={{ background: "#fff", padding: "36px 40px 40px" }}>
          {error && (
            <Alert
              type="error"
              message={error}
              style={{ marginBottom: 20, borderRadius: 8 }}
              showIcon
            />
          )}

          <Form layout="vertical" onFinish={onFinish}>
            <Form.Item
              label={<span style={{ fontWeight: 600, color: "#333" }}>Username</span>}
              name="username"
              rules={[{ required: true, message: "Please input your username!" }]}
            >
              <Input autoFocus size="large" style={{ borderRadius: 4 }} />
            </Form.Item>

            <Form.Item
              label={<span style={{ fontWeight: 600, color: "#333" }}>Password</span>}
              name="password"
              rules={[{ required: true, message: "Please input your password!" }]}
            >
              <Input.Password size="large" style={{ borderRadius: 4 }} />
            </Form.Item>

            <Form.Item style={{ marginTop: 8, marginBottom: 0 }}>
              <Button
                htmlType="submit"
                block
                size="large"
                loading={loading}
                disabled={loading}
                style={{
                  background: ORANGE,
                  borderColor: ORANGE,
                  color: "#fff",
                  borderRadius: 4,
                  fontWeight: 700,
                  fontSize: 15,
                  height: 48,
                  boxShadow: "0 4px 16px rgba(255,122,0,0.4)",
                }}
              >
                Sign In
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};
